(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl_back-to-top"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('bl-back-to-top')) {
    class BlBackToTop extends HTMLElement {
      connectedCallback() {
        // Move to <body> so the button works wherever the section is placed (e.g. a footer group hidden on mobile).
        // Moving re-triggers connectedCallback, so setup runs on the second call.
        if (this.parentElement !== document.body) {
          document.querySelectorAll(`body > bl-back-to-top[data-section-id="${this.dataset.sectionId}"]`).forEach((old) => old.remove());
          document.body.append(this);
          return;
        }

        // Theme editor: the moved button is outside its section, so remove it when the section reloads or is removed
        this.onSectionUnload = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.remove();
        };
        document.addEventListener('shopify:section:unload', this.onSectionUnload);

        this.button = this.querySelector('button');
        this.button.addEventListener('click', () => this.scrollToTop());

        // First visible section of the page content (skips disabled/empty sections and this section)
        const main = document.querySelector('[role="main"], main') || document.body;
        const firstSection = Array.from(main.querySelectorAll(':scope > .shopify-section')).find(
          (section) => section.offsetHeight > 0 && !section.contains(this)
        );

        if (!firstSection) {
          this.setVisible(true);
          return;
        }

        // Visible once the first section has scrolled completely above the top of the screen
        this.observer = new IntersectionObserver(([entry]) => {
          this.setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.observer.observe(firstSection);

        // Theme editor: show the button while its section is selected
        this.onSectionSelect = (event) => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.setVisible(true);
        };
        document.addEventListener('shopify:section:select', this.onSectionSelect);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('shopify:section:select', this.onSectionSelect);
        document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      }

      setVisible(visible) {
        this.button.classList.toggle('is-visible', visible);
        this.button.tabIndex = visible ? 0 : -1;
      }

      scrollToTop() {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });

        // Move keyboard focus back to the top of the page as well
        const target = document.querySelector('#main, [role="main"], main');
        if (target) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }
      }
    }

    window.customElements.define('bl-back-to-top', BlBackToTop);
  }

  } catch(e) { console.error(e); }
})();
})();
